import LetterPostboxes from './letterPostboxes';

export default LetterPostboxes;
